export const getProgrammableTags = (state: any) => {
  return state.programmableTags.programmableTags;
};
